exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".UploadModal__UploadModal__acb5nE {\n  background: #d13f19;\n}\n.UploadModal__inline__3iHRf8 {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n.UploadModal__inputSpinner__2hiyZw {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.UploadModal__grayButton__17vY53 {\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n  border: 1px solid #d9d9d9;\n  color: #4a4a4a;\n/*\n  New Redesign Buttons\n  DEBUG: Folders\n  */\n  margin-top: 20px;\n}\n.UploadModal__grayButton__17vY53:hover {\n  background: linear-gradient(to bottom, #f7f7f7, #b3b3b3);\n  color: #4a4a4a;\n}\n.UploadModal__ModalChildren__2UWoh0 {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"UploadModal": "UploadModal__UploadModal__acb5nE",
	"inline": "UploadModal__inline__3iHRf8",
	"inputSpinner": "UploadModal__inputSpinner__2hiyZw",
	"grayButton": "UploadModal__grayButton__17vY53",
	"ModalChildren": "UploadModal__ModalChildren__2UWoh0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/UploadModal.styl
// module id = 3604
// module chunks = 39